import * as _ from 'underscore';
import { IGetPrincipalNamesResult } from '../ServerApi/requests/GetPrincipalNamesRequest';
import { IPrincipal } from '../ServerApi/types/IPrincipal';

export module PrincipalMapper {

  export function map(container: IGetPrincipalNamesResult): IPrincipal[] {
    return _.map(container.users, mapOne);
  }

  // mapping here is doing a hopefully redundant check that the backend has translated
  // group objects with just one 'name' into a principal object with two name fields
  export function mapOne(p: IPrincipal): IPrincipal {
    return {
      displayName: p.displayName || p.name,
      domainName:  p.domainName,
      id:          p.id,
      luid:        p.luid,
      siteId:      p.siteId,
      type:        p.type.indexOf('user') >= 0 ? 'user' : 'group',
      username:    p.username || p.name
    };
  }

}
